import PropTypes from 'prop-types'
import React from 'react'

import { toFixed } from './to-fixed'

function capVelocity(props) {
  return state => {
    const direction = state.velocity < 0 ? -1 : 1
    const velocity =
      Math.min(Math.abs(state.velocity), props.maxVelocity) * direction
    return { velocity }
  }
}

function decelerate(props) {
  return state => ({
    velocity: toFixed(2, state.velocity * props.drag),
  })
}

export class ScrollableRow extends React.Component {
  constructor(props) {
    super(props)

    this.handleFinish = this.handleFinish.bind(this)
    this.handleInertia = this.handleInertia.bind(this)
    this.handleMouseDown = this.handleMouseDown.bind(this)
    this.handleMouseMove = this.handleMouseMove.bind(this)
    this.handleMouseUp = this.handleMouseUp.bind(this)
    this.handleTouchStart = this.handleTouchStart.bind(this)
    this.handleTouchMove = this.handleTouchMove.bind(this)
    this.handleTouchEnd = this.handleTouchEnd.bind(this)
    this.handleWheel = this.handleWheel.bind(this)

    this.state = {}

    this.ref = React.createRef()
  }

  handleMouseDown(event) {
    if ((event.button === 1 && window.event != null) || event.button === 0) {
      this.handleStart(event.clientX)

      document.addEventListener('mousemove', this.handleMouseMove)
      document.addEventListener('mouseup', this.handleMouseUp)
    }
  }

  handleMouseMove(event) {
    this.handleMove(event.clientX)
  }

  handleMouseUp() {
    document.removeEventListener('mousemove', this.handleMouseMove)
    document.removeEventListener('mouseup', this.handleMouseUp)

    this.handleFinish()
  }

  handleTouchStart(event) {
    if (event.changedTouches) {
      const touch = event.changedTouches[0]

      this.handleStart(touch.clientX || event.clientX)

      document.addEventListener('touchmove', this.handleTouchMove)
      document.addEventListener('touchend', this.handleTouchEnd)
    }
  }

  handleTouchMove(event) {
    event.preventDefault()

    if (event.changedTouches) {
      const touch = event.changedTouches[0]
      this.handleMove(touch.clientX || event.clientX)
    }
  }

  handleTouchEnd() {
    document.removeEventListener('touchmove', this.handleTouchMove)
    document.removeEventListener('touchend', this.handleTouchEnd)
    this.handleFinish()
  }

  handleWheel(event) {
    const node = this.ref.current
    if (node) {
      node.scrollLeft = node.scrollLeft + event.deltaX
    }
  }

  handleStart(start) {
    const node = this.ref.current
    if (node) {
      this.setState({
        offset: node.scrollLeft,
        start,
        velocity: 0,
      })
    }
  }

  handleMove(position) {
    const node = this.ref.current
    if (node) {
      const prevScrollLeft = node.scrollLeft
      node.scrollLeft = this.state.offset + (-position + this.state.start)
      this.setState({
        velocity: node.scrollLeft - prevScrollLeft,
      })
    }
  }

  handleFinish() {
    this.setState(capVelocity(this.props))

    if (this.state.velocity !== 0) {
      window.requestAnimationFrame(this.handleInertia)
    }
  }

  handleInertia() {
    this.setState(decelerate(this.props))

    const node = this.ref.current
    if (node) {
      // scroll position must be integer
      node.scrollLeft = Math.round(node.scrollLeft + this.state.velocity)
    }

    if (Math.floor(Math.abs(this.state.velocity)) !== 0) {
      window.requestAnimationFrame(this.handleInertia)
    }
  }

  render() {
    return (
      <div
        ref={this.ref}
        style={{ overflow: 'hidden' }}
        onMouseDown={this.handleMouseDown}
        onTouchStart={this.handleTouchStart}
        onWheel={this.handleWheel}
      >
        {this.props.children}
      </div>
    )
  }
}

ScrollableRow.defaultProps = {
  drag: 0.9,
  maxVelocity: 40,
}

ScrollableRow.propTypes = {
  children: PropTypes.node,
  drag: PropTypes.number,
  maxVelocity: PropTypes.number,
}
